<div class="screen-container d-flex fd-col jc-start ai-stretch">

  <div class="d-flex fd-row flex-wrap jc-start ai-stretch">
    <h4 class="margin">Member List</h4>
  </div>

  <div class="d-flex fd-row flex-wrap jc-start ai-stretch">
    <div class="margin card flex-1 d-flex fd-col ai-stretch">
      <!-- <suvo-bi-organisation-invite-list></suvo-bi-organisation-invite-list> -->
      <suvo-bi-organisation-members-view></suvo-bi-organisation-members-view>
    </div>
  </div>

  <div class="top-margin d-flex fd-row flex-wrap jc-start ai-stretch">
    <h4 class="margin">Outgoing Invitations</h4>
  </div>

  <div class="d-flex fd-row flex-wrap jc-start ai-stretch">
    <div class="margin card flex-1 d-flex fd-col ai-stretch">
      <div class="padding">
        <p>Manage active / sent invites from the selected organisation here.</p>
      </div>
    </div>
  </div>


</div>